import { useSelector } from 'react-redux';
import { getGeneralServiceOrderNoteByServiceOrderId } from '@mews-commander/legacy-entities/src/ducks';
import { ApplicationState, WithServiceOrderId } from '@mews-commander/types';

export const ProductServiceOrderNoteText = ({ serviceOrderId }: WithServiceOrderId) => {
    const note = useSelector((state: ApplicationState) =>
        getGeneralServiceOrderNoteByServiceOrderId(state, { serviceOrderId })
    );

    return note?.text ? <>{note.text}</> : null;
};
